import { render, staticRenderFns } from "./metrics-sparkline.vue?vue&type=template&id=747d72aa&"
import script from "./metrics-sparkline.vue?vue&type=script&lang=js&"
export * from "./metrics-sparkline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports